
import React      from 'react';
import CSSModules from 'react-css-modules';
import moment     from 'moment';

import style from './style.scss';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import PromotionForm    from '../PromotionForm';
import YesNoOptionPanel from '../YesNoOptionPanel';
import Checkbox         from '../Checkbox';

import promotionRepo from '../../services/promotionCodes';

import * as promotionActions from '../../actions/promotionList';

import { connect } from 'react-redux';

class PromotionList extends React.Component {

    componentDidMount() {

        this.props.refreshPromotions();
    }

    _getDeletePromoMessage() {

        const promoToDelete = this.props.promotionToDelete;

        return (
            <div>
                <p>
                    Are you sure you want to delete promotion code <span styleName="promo-to-delete">{ promoToDelete.code }</span>?
                </p>

                <YesNoOptionPanel no={ this.props.hideDeletePromoCodeOverlay }
                                  yes={ this.props.deletePromotion.bind(this, promoToDelete.id) } />

            </div>
        );
    }

    _getOneTimeUseCheckbox(isOneTimeUse) {

        return <Checkbox readOnly checked={ isOneTimeUse } />
    }

    _formatExpiryDate(date) {

        return moment(date).format('DD.MM.YYYY');
    }

    _formatValue(value, discountType) {

        if (discountType === 'fixed_value') {

            return '£' + parseFloat(value).toFixed(2);

        }
        else if (discountType === 'fixed_percentage') {

            return parseFloat(value).toFixed(2) + '%';
        }
        else {

            return parseFloat(value).toFixed(2);
        }

    }

    _getPromotionsTable() {

        if (this.props.promotions.length > 0) {

            return (
                <table styleName="promo-table">
                    <thead>
                    <tr>
                        <th>Type</th>
                        <th>Code</th>
                        <th>Value</th>
                        <th>One-time Use</th>
                        <th>Expiry Date</th>
                        <th>Limited to Course</th>
                    </tr>
                    </thead>
                    <tbody>

                    {
                        this.props.promotions.map((promotion, index) => {

                            return (
                                <tr key={ index }>
                                    <td>{ promotionRepo.typeToDescription(promotion.type) }</td>
                                    <td>{ promotion.code }</td>
                                    <td>{ promotion.value ? this._formatValue(promotion.value, promotion.type) : '\u2014' }</td>
                                    <td>{ this._getOneTimeUseCheckbox(promotion.one_time_use) }</td>
                                    <td>{ promotion.expires ? this._formatExpiryDate(promotion.expiry_date) : '\u2014' }</td>
                                    <td>{ promotion.limited_to_course && promotion.course ? promotion.course.name : '\u2014' }</td>
                                    <td>
                                        <a styleName="edit-link"
                                           onClick={ this.props.showEditPromoOverlay.bind(this, promotion) }>
                                            Edit
                                        </a>
                                        <a styleName="delete-link"
                                           onClick={ this.props.showDeletePromoOverlay.bind(this, promotion) }>
                                            Delete
                                        </a>
                                    </td>
                                </tr>
                            );
                        })
                    }

                    </tbody>
                </table>
            );
        }
    }

    render() {

        return (
            <article>

                <Overlay isOpen={ this.props.isDeletePromoCodeOverlayOpen }
                         closeOverlay={ this.props.hideDeletePromoCodeOverlay }
                         title="Delete Promotion"
                         size="small">

                    { this.props.isDeletePromoCodeOverlayOpen ? this._getDeletePromoMessage() : null }

                </Overlay>

                <Overlay isOpen={ this.props.promotionToEdit }
                         closeOverlay={ this.props.hideEditPromoCodeOverlay }
                         title="Edit Promotion"
                         size="small">

                    <PromotionForm mode="edit"
                                   promotion={ this.props.promotionToEdit }
                                   onSubmitSuccess={ this.props.promotionUpdated } />

                </Overlay>

                <Overlay isOpen={ this.props.isNewPromoCodeOverlayOpen }
                         closeOverlay={ this.props.hideNewPromoCodeOverlay }
                         title="New Promotion"
                         size="small">

                    <PromotionForm mode="add" onSubmitSuccess={ this.props.promotionCreated } />

                </Overlay>

                <Button onClick={ this.props.showNewPromoCodeOverlay }>
                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New promotion</span>
                </Button>

                { this._getPromotionsTable() }

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.promotionList;
}

function mapDispatchToProps(dispatch) {

    return {
        hideEditPromoCodeOverlay() {

            dispatch(promotionActions.hideEditPromoCodeOverlay());
        },
        deletePromotion(promotionId) {

            dispatch(promotionActions.deletePromotion(promotionId));
        },
        hideDeletePromoCodeOverlay() {

            dispatch(promotionActions.hideDeletePromoOverlay());
        },
        showEditPromoOverlay(promotion) {

            dispatch(promotionActions.showEditPromoOverlay(promotion));
        },
        showDeletePromoOverlay(promotion) {

            dispatch(promotionActions.showDeletePromoOverlay(promotion));
        },
        promotionCreated() {

            dispatch(promotionActions.hideNewPromoCodeOverlay());
            dispatch(promotionActions.refreshPromotions());
        },
        promotionUpdated() {

            dispatch(promotionActions.hideEditPromoCodeOverlay());
            dispatch(promotionActions.refreshPromotions());
        },
        showNewPromoCodeOverlay() {

            dispatch(promotionActions.showNewPromoCodeOverlay());
        },
        hideNewPromoCodeOverlay() {

            dispatch(promotionActions.hideNewPromoCodeOverlay());
        },
        refreshPromotions() {

            dispatch(promotionActions.refreshPromotions());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(PromotionList, style));


// WEBPACK FOOTER //
// ./components/PromotionList/index.js